export function orderBySection(errors) {
  return Object.keys(errors).reduce((sections, name) => {
    // saltamos "CAB"
    orderBySection(errors[name].properties, sections);
    setCounters(sections);
    return sections;
  }, {});

  function orderBySection(propertiesFromCAB, sections = {}) {
    return Object.keys(propertiesFromCAB).reduce((acc, cur) => {
      const property = propertiesFromCAB[cur];
      if (!property.section) {
        // property que no tiene "section"
        // puede ser tipicamente un tipo objeto que no se representa en el view,
        // pero tratamos sus hijos
        if (!property.properties && !Object.keys(property.properties).length) {
          return acc;
        } // ERROR no tiene hijos. Lo saltamos
        return orderBySection(property.properties, sections);
      }
      acc[property.section.name] = acc[property.section.name] || {
        properties: {},
      };
      acc[property.section.name].properties[cur] = property;
      acc[property.section.name].title = property.section.title;
      return acc;
    }, sections);
  }

  function setCounters(sections) {
    Object.values(sections).forEach(section => (section.counter = count(section)));

    function count(section) {
      return Object.values(section.properties).reduce((acc, cur) => acc + (cur.errors || []).length + (cur.properties ? count(cur) : 0), 0);
    }
  }
}
